import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Mountain } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/creatives`;

export const ScenesDialog = ({ body, estCost, onClose, onDone }) => {
  const [scenes, setScenes] = useState([]);
  const [picked, setPicked] = useState([]);
  const [custom, setCustom] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { axios.get(`${API}/scenes`).then((r) => setScenes(r.data.items || [])).catch(() => {}); }, []);
  const max = custom.trim() ? 3 : 4;
  const toggle = (k) => setPicked((p) => (p.includes(k) ? p.filter((x) => x !== k) : p.length >= max ? p : [...p, k]));
  const count = Math.min(picked.length, max) + (custom.trim() ? 1 : 0);

  const go = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/sessions/scenes`, { ...body, scenes: picked.slice(0, max), custom }, { timeout: 90000 });
      toast.success(`${count} scene în lucru — ~1 minut`);
      onDone(r.data); onClose();
    } catch (e) { toast.error(e.response?.data?.detail || e.message); }
    setBusy(false);
  };

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent data-testid="scenes-dialog" className="max-w-lg">
        <DialogHeader><DialogTitle>Pune produsul în scene noi</DialogTitle></DialogHeader>
        <p className="text-xs text-zinc-500">Folosește pozele selectate (fundal alb). AI-ul așază produsul neschimbat în fiecare scenă, cu umbre și lumină reale. Max. 4 scene.</p>
        <div className="flex flex-wrap gap-2">
          {scenes.map((s) => (
            <button key={s.key} data-testid={`scene-${s.key}`} onClick={() => toggle(s.key)}
              className={`rounded-full border px-3 py-1 text-xs transition-colors ${picked.includes(s.key) ? "border-amber-400 bg-amber-400 text-zinc-950" : "border-zinc-300 text-zinc-700 hover:border-amber-500"}`}>{s.label}</button>
          ))}
        </div>
        <Textarea data-testid="scene-custom-input" value={custom} onChange={(e) => setCustom(e.target.value)} rows={2}
          placeholder="Scena ta (opțional): ex. pe o masă de lemn la cabană, cu zăpadă afară" />
        <button data-testid="scenes-generate-btn" onClick={go} disabled={busy || !count}
          className="flex items-center justify-center gap-2 rounded-full bg-amber-400 py-2.5 text-sm font-semibold text-zinc-950 disabled:opacity-50">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Mountain className="h-4 w-4" />} Generează {count || ""} scen{count === 1 ? "ă" : "e"}{count ? ` · ~$${(estCost * count).toFixed(2)}` : ""}
        </button>
      </DialogContent>
    </Dialog>
  );
};
